import React from "react";
import FormDataProvider from "integrations/contexts/FormDataProvider";
import { SidebarProvider } from "./context/Sidebar";
import { StepsProvider } from "./context/Steps";
import { AdvancedOptionsProvider } from "./context/AdvancedOptions";
import CrowdStrike from "./CrowdStrike";
import INITIAL_FORMDATA from "./_initialFormData";
const EmbeddedCrowdStrikeApp = () => /* @__PURE__ */ React.createElement(StepsProvider, null, /* @__PURE__ */ React.createElement(FormDataProvider, { initialFormData: INITIAL_FORMDATA }, /* @__PURE__ */ React.createElement(SidebarProvider, null, /* @__PURE__ */ React.createElement(AdvancedOptionsProvider, null, /* @__PURE__ */ React.createElement(CrowdStrike, { externalInputSubmit: false })))));
export default EmbeddedCrowdStrikeApp;
